import { urls } from './urls';
import axios from 'axios';
import { getCookie, isWebView } from 'utils/cookies';

const EXPENSE_TYPE = {
  CONSIGNER: 'getShipperExpense',
  OPERATOR: 'getOperatorExpense',
};

const BOOLEAN_MAP = {
  true: true,
  false: false,
};

export function consignerRequest(params) {
  return buildApiRequest('GET', urls.getConsigners, { pageNo: params.page, size: params.size, type: params.type });
}
// ?code=WE2100045&page=0&size=10

export function consignerTransactionsList(params) {
  return buildApiRequest('GET', urls.transactionsListUrl, { code: params.code, page: params.page, size: params.size });
}

export function cashBackType(params) {
  return buildApiRequest('GET', urls.getCashBackType, { code: params.code });
}

export function consignerBillingDetails({ code, id }) {
  return buildApiRequest('GET', `${urls.getBillingDetails}?consignerCode=${code}`);
}

export function updateConsignerBillingAccount(payload) {
  return buildApiRequest('POST', `${urls.updateConsignerBillingAccount}`, { ...payload });
}

export function updateConsignerPanGst(payload) {
  return buildApiRequest('PATCH', `${urls.updateConsignerPanGst}`, { ...payload });
}
export function saveBasicDetailsRequest(params) {
  return buildApiRequest('PATCH', urls.saveBasicDetailsUrl(params.consignmentId), params.payload);
}

export function createConsignerPanGst(payload) {
  return buildApiRequest('POST', `${urls.updateConsignerPanGst}`, { ...payload });
}

export function addNewTransactionApi(payload) {
  return buildApiRequest('POST', `${urls.addNewTransactionUrl}`, { ...payload });
}

export function viewPreSignedUrl({ code }) {
  return buildApiRequest('GET', `${urls.consignerV2}/${code}/preSignedUrl/view`);
}

export function uploadPreSignedUrl({ documentType, fileExtension }) {
  return buildApiRequest(
    'GET',
    `${urls.uploadPreSignedUrl}?documentType=${documentType}&fileExtension=${fileExtension}`,
  );
}

export function uploadToPreSignedUrl(url, payload) {
  return buildApiRequest('PUT', url, payload, true);
}

export function viewFileRequest(file) {
  return buildApiRequest('GET', urls.viewFile, { filePath: file });
}

export function consignerByCodeRequest(cCode) {
  return buildApiRequest('GET', `${urls.getConsignerByCode}${cCode}`);
}

export function vpaByCodeRequest(cCode) {
  return buildApiRequest('GET', urls.getConsignerVpa, { code: cCode });
}

export function addressByCodeRequest(cCode) {
  return buildApiRequest('GET', urls.getConsignerAddress, {
    consignerCode: cCode,
  });
}

export function operatorByIdRequest(id) {
  return buildApiRequest('GET', urls.operatorById, {
    id: id,
  });
}

export function bankByOpIdRequest(id) {
  return buildApiRequest('GET', urls.bankByOpId, {
    opId: id,
  });
}

export function uploadGstUrlRequest(params) {
  return buildApiRequest('GET', urls.getUploadGstUrl, {
    consignerCode: params.cCode,
    gstNumber: params.gstNum,
  });
}

export function viewGstUrlRequest(params) {
  return buildApiRequest('GET', urls.getViewGstUrl, {
    consignerCode: params.cCode,
    gstNumber: params.gstNum,
  });
}

export function fileViewRequest(params) {
  return buildApiRequest('GET', urls.viewOperatorFile, {
    id: params.id,
    'file-name': params.fileName,
  });
}

export function viewTdsFileRequest(payload) {
  return buildApiRequest('GET', `${urls.operatorsList}/${payload.id}/tds-declaration/view-url`, {
    'file-path': payload.filePath,
  });
}

export function getVehiclesListRequest(params) {
  return buildApiRequest('GET', urls.vehiclesList, params);
}

export function createOperatorVehicleRequest(payload) {
  return buildApiRequest('POST', `${urls.operatorBasicDetails}/vehicles/add-vehicle`, payload);
}

export function searchResultsRequest(params) {
  return buildApiRequest('GET', urls.getSearchResults, {
    expression: params.expression,
    pageNo: params.pageNo,
    size: params.size,
    type: params.type,
  });
}

export function operatorSearchRequest(params) {
  return buildApiRequest('GET', urls.getOperatorSearch, {
    expression: params.expression,
    page: params.pageNo,
    size: params.size,
    status: params.type,
  });
}

export function viewConsignerFileRequest(params) {
  return buildApiRequest('GET', urls.viewConsignerFile, {
    docType: params.docType,
    consignerCode: params.cCode,
  });
}

export function vpaDetailsRequest(params) {
  return buildApiRequest('GET', urls.getConsignerVpa, {
    code: params.cCode,
  });
}

export function downloadLedgerRequest(params) {
  return buildApiRequest('GET', urls.downloadLedger, {
    opId: params.opId,
    consignmentCodes: params.cCodes.toString(),
  });
}

export function operationSearchRequest(params) {
  return buildApiRequest('GET', urls.operationSearchUrl, params);
}

export function gstByCodeRequest(cCode) {
  return buildApiRequest('GET', urls.getConsignerGst, {
    code: cCode,
  });
}

export function getWalletbalance(cCode) {
  return buildApiRequest('GET', urls.getConsignerWalletBalance, {
    code: cCode,
  });
}

export function createConsignerRequest(payload) {
  return buildApiRequest('POST', urls.getConsignerByCode, payload);
}

export function uploadDocumentRequest(payload) {
  return buildApiRequest('PUT', urls.uploadFile, payload);
}

export function editCompliancesRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignerByCode}${payload.id}/compliance`, payload.payload);
}

export function editPaymentRequest(payload) {
  return buildApiRequest('POST', urls.getUpdateConsignerPaymentModeOptions(), payload.payload);
}

export function editBusinessRequest(payload) {
  return buildApiRequest(
    'PATCH',
    `${urls.editBusinessDetail}/${payload.consignerCode}/business-detail`,
    payload.payload,
  );
}

export function editNotificationRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignerByCode}${payload.id}/notification-details`, payload.payload);
}

export function saveEditedAddressRequest(payload) {
  return buildApiRequest('PUT', urls.saveConsignerAddress, payload);
}

export function editBasicDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignerByCode}${payload.id}/basic-detail`, payload.payload);
}

export function editVpaDetailsRequest(payload) {
  return buildApiRequest('PUT', urls.getConsignerVpa, payload);
}

export function createVpaDetailsRequest(payload) {
  return buildApiRequest('POST', urls.getConsignerVpa, payload);
}

export function createNewAddressRequest(payload) {
  return buildApiRequest('POST', urls.createConsignerAddress, payload);
}

export function saveConsignerGstRequest(payload) {
  return buildApiRequest('PUT', urls.saveConsignerGst, payload);
}

export function createConsignerGstRequest(payload) {
  return buildApiRequest('PUT', urls.createConsignerGst, payload);
}

export function createAccountRequest(payload) {
  return buildApiRequest('POST', urls.createBankAccount, payload);
}

export function editAccountRequest(payload) {
  return buildApiRequest('PUT', urls.editBankAccount, payload);
}

export function createOperatorRequest(payload) {
  return buildApiRequest('POST', urls.operatorsList, payload);
}

export function disableEditRequest(payload) {
  return buildApiRequest('PUT', urls.disableEdit, { id: payload.id, state: payload.state });
}

// export function addTdsDeclarationRequest(payload) {
//   return buildApiRequest('POST', urls.tdsDeclarations, { ...payload });
// }

// export function editTdsDeclarationRequest(payload) {
//   return buildApiRequest('PUT', `${urls.tdsDeclarations}/${payload.id}`, { ...payload.payload });
// }

export function editOnboardingDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorsList}/${payload.id}/onboarding-detail`, { ...payload.payload });
}

export function getLanesOptionsRequest() {
  return buildApiRequest('GET', `${urls.operatorsList}/destinies`);
}

export function sendToThirdPartyRequest(payload) {
  return buildApiRequest('PUT', urls.sendToThirdParty, { id: payload.id });
}

export function updateOperatorRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorsList}/${payload.id}/basic-detail`, payload.payload);
}

export function updateCompanyRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorsList}/${payload.id}/company-details`, payload.payload);
}

export function updateDocumentsRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorsList}/${payload.id}/document`, payload.payload);
}

export function settleTripRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorsList}/${payload.id}/settle-consignment`, payload.payload);
}

export function deletePocRequest(id) {
  return buildApiRequest('DELETE', urls.deletePoc, { id: id });
}

export function deleteAddressRequest(id) {
  return buildApiRequest('DELETE', urls.deleteAddress, { id: id });
}

export function deleteGstRequest(id) {
  return buildApiRequest('DELETE', `${urls.saveConsignerGst}/${id}`);
}

export function getThirdPartyListRequest() {
  return buildApiRequest('GET', urls.getThirdPartyList, { opId: 'third_party' });
}

export function getLaneRateListRequest(params) {
  return buildApiRequest('GET', urls.getLaneRateList, params);
}

export function consignerTypeRequest() {
  return buildApiRequest('GET', urls.getConsignerType);
}

export function consignerCashbackTypeRequest(params) {
  return buildApiRequest('GET', urls.getCashBackType, { code: params.code });
}

export function consignerStatusRequest() {
  return buildApiRequest('GET', urls.getConsignerStatus);
}

export function operatorTypeRequest() {
  return buildApiRequest('GET', urls.operatorType);
}

export function consignmentStatesRequest() {
  return buildApiRequest('GET', urls.consignmentStates);
}

export function getConsignmentsRequest(params) {
  return buildApiRequest('GET', urls.getConsignments, {
    ...params,
    'to-pay': params['to=pay'] !== null ? BOOLEAN_MAP[params['to-pay']] : null,
  });
}

export function getBankDetailsRequest(params) {
  return buildApiRequest('GET', urls.getBankAccounts, params);
}

export function getSupplyDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params.consignmentId}/supply-details`);
}

export function getDocketsRequest(params) {
  return buildApiRequest('GET', `${urls.getDockets}`, params);
}

export function getInvoicesRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/get-docs-by-consignment-id`, params);
}

export function getInsuranceRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params['consignment-id']}/document/insurance`);
}

export function getAddressDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.demandId}/address`);
}
export function getAddressDetailsRequestOperationV4(params) {
  return buildApiRequest('GET', `${urls.getDemandsOperationV4}/${params.demandId}/addresses`);
}
export function viewDocketFilesRequest(params) {
  return buildApiRequest('GET', `${urls.getDockets}/${params.docketId}/pod-view-url`, params.params);
}

export function viewInvoiceRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/view-url?invoiceId=${params.documentId}`, {
    filePath: params.filePath,
  });
}

export function viewInsuranceRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/view-url?invoiceId=${params.insuranceNumber}`, {
    filePath: params.filePath,
  });
}

export function indentsListRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}`, params);
}

export function getEmailsListRequest(params) {
  return buildApiRequest('GET', `${urls.getEmails}`, params);
}
export function getDistrictOriginRequest(params) {
  return buildApiRequest('GET', `${urls.getDistricts}`, params);
}
export function getEmailsListRequestOperations(params) {
  return buildApiRequest('GET', `${urls.getOperationsAssignToEmailList}`, params);
}

export function getHeaderDetailsRequest(did) {
  return buildApiRequest('GET', `${urls.getDemands}/${did}/placement-basic-details`);
}

export function assignIndentRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${payload.dId}/assign`, payload.payload);
}

export function tripDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params.consignmentId}/trip-details`);
}

export function currentLocationRequest(params) {
  return buildApiRequest('GET', `${urls.currentLocation}`, { 'consignment-id': params.consignmentId });
}

export function getViaPointsRequest(params) {
  return buildApiRequest('GET', `${urls.viaPoints}`, params);
}

export function expenseTypesRequest(params) {
  return buildApiRequest('GET', `${urls.addExpense}/types`, params);
}

export function expenseTypesV3Request(params) {
  return buildApiRequest('GET', `${urls.addExpenseNew}/types`, params);
}

export function remarksRequest(params) {
  return buildApiRequest('GET', `${urls.getTransactions}/remarks`, params);
}

export function TdsInfoRequest(params) {
  return buildApiRequest('GET', `${urls.getTdsInfo}/${params.demandId}/tds/info`);
}

export function viewFreightRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.demandId}/sfa-view-url`, {
    'file-name': params['file-name'],
  });
}

export function fetchExpireReasons() {
  return buildApiRequest('GET', `${urls.getDemands}/expire-reasons`);
}

export function expireIndent(demandId, params) {
  return buildApiRequest('POST', `${urls.getDemands}/${demandId}/expire`, params);
}

export function updateBasicDetailRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/operator`, payload.payload);
}

export function updateTimeRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/vehicle-state-time`, payload.payload);
}

export function vehicleDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/vehicle`, payload.payload);
}

export function updateDemandDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${payload.demandId}/basic-details`, payload.payload);
}

export function editAddressPointRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${payload.demandId}/address`, payload.payload);
}

export function editLaneNameRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${payload.demandId}/laneName`, payload.payload);
}

export function settleOperatorRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/settle-operator`, payload.payload);
}

export function settleShipperRequest(payload) {
  return buildApiRequest('PUT', `${urls.settleShipper}`, payload);
}

export function updateFreightDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${payload.demandId}/freight-details`, payload.payload);
}

export function updateOperatorFreightDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/supply-freight`, payload.payload);
}

export function driverDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/driver`, payload.payload);
}

export function editInvoiceDocRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/doc-update`, payload.payload);
}

export function createTransactionRequest(payload) {
  return buildApiRequest('POST', `${urls.getTransactions}`, payload);
}

export function createViaPointRequest(payload) {
  return buildApiRequest('POST', `${urls.createViaPoint}`, payload);
}

export function editViaPointRequest(payload) {
  return buildApiRequest('PUT', `${urls.createViaPoint}`, payload);
}

export function addExpenseRequest(payload) {
  return buildApiRequest('POST', `${urls.addExpense}`, payload);
}

export function editExpenseRequest(payload) {
  return buildApiRequest('PUT', `${urls.addExpense}/${payload.id}`, payload.payload);
}

export function createDocketRequest(payload) {
  return buildApiRequest('POST', `${urls.docketApi}`, payload);
}

export function sharePaymentLinkRequest(params) {
  return buildApiRequest('POST', `${urls.sharePaymentLinkApi(params.demandId)}`, params.payload);
}

export function createTriggerConsignerRequest(payload) {
  return buildApiRequest('POST', `${urls.getConsignments}/notifyconsigner`, payload);
}
export function createInvoiceRequest(payload) {
  return buildApiRequest('POST', `${urls.docketApi}/${payload.docketId}/invoice`, payload.payload);
}

export function editInvoiceRequest(payload) {
  return buildApiRequest('PUT', `${urls.docketApi}/${payload.docketId}/invoice/${payload.invoiceId}`, payload.payload);
}

export function editInsuranceRequest(payload) {
  return buildApiRequest('PUT', `${urls.docke}`);
}

export function editDocketRequest(payload) {
  return buildApiRequest('PUT', `${urls.docketApi}/${payload.docketId}`, payload.payload);
}

export function deleteDocketRequest(payload) {
  return buildApiRequest('PUT', `${urls.getDockets}/${payload.docketId}/delete`, {});
}

export function deleteInvoiceRequest(payload) {
  return buildApiRequest('DELETE', `${urls.getConsignments}/doc-delete?document-id=${payload}`);
}

export function saveRcUrlRequest(payload) {
  return buildApiRequest('PUT', `${urls.rcSave}`, payload);
}

export function editTransactionRequest(payload) {
  return buildApiRequest('PUT', `${urls.getTransactions}/${payload.transactionId}`, payload.payload);
}

export function getBasicDetailsRequest(consignmentId) {
  return buildApiRequest('GET', `${urls.getConsignments}/${consignmentId}/basic-details`);
}

export function getCurrentDocketRequest(docketId) {
  return buildApiRequest('GET', `${urls.docketApi}/${docketId}`);
}

export function getDemandDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemandsBasicDetails}/${params.consignmentId}/details`);
}

export function operatorByPhoneRequest(phone) {
  return buildApiRequest('GET', `${urls.getOperatorByPhone}/${phone}`);
}

export function getMgDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params.consignmentId}/supply-mg-details`);
}

export function getTransactionsRequest(params) {
  return buildApiRequest('GET', urls.getTransactions, {
    'demand-id': params.demandId,
    'party-type': params.type,
    'consignment-id': params.consignmentId,
  });
}

export function getUserDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.demandId}/user-details`);
}

export function getExpenseRequest(params) {
  return buildApiRequest('GET', urls[EXPENSE_TYPE[params.type]], {
    'consignment-id': params.consignmentId,
    'demand-id': params.demandId,
  });
}

export function getThirdPartyTransactionsRequest(params) {
  return buildApiRequest('GET', urls.getTransactions, {
    'demand-id': params.demandId,
    'party-type': 'THIRD_PARTY',
    'consignment-id': params.consignmentId,
  });
}

export function getThirdPartyExpenseRequest(params) {
  return buildApiRequest('GET', urls.getThirdPartyExpense, { 'consignment-id': params.consignmentId });
}

export function getCommentsRequest(params) {
  return buildApiRequest('GET', urls.getComments, { 'demand-id': params.demandId, context: 'OPERATION' });
}

export function getCommentCategories(params) {
  return buildApiRequest('GET', `${urls.getComments}/categories?context=${params.context}`);
}

export function getAuditRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params.consignmentId}/state-details`);
}

export function postCommentRequest(payload) {
  return buildApiRequest('POST', urls.getComments, payload);
}

export function operatorStatusRequest() {
  return buildApiRequest('GET', urls.operatorStatus);
}

export function phoneNoRequest(params) {
  return buildApiRequest('GET', `${urls.getPhoneNo}?code=${params.code}&codeType=${params.codeType}`);
}

export function getTripsRequest(params) {
  return buildApiRequest('GET', `${urls.operatorsList2}/${params.opCode}/consignments`, {
    // return buildApiRequest('GET', `${'http://odin.staging-we.com/odin/v2/operator'}/${params.opCode}/consignments`, {

    size: params.size,
    page: params.pageNo,
    settled: params.settled,
    code: params?.code,
    vehicleNumber: params?.vehicleNumber,
  });
}

export function getOperatorsListRequest(params) {
  return buildApiRequest('GET', urls.getOperatorSearch, { page: params.page, size: params.size, status: params.type });
}

export function getOperatorByIdRequest(id) {
  return buildApiRequest('GET', `${urls.operatorsList}/${id}/basic-detail`);
}
export function getOperatorKycHistory(code) {
  return buildApiRequest('GET', `${urls.operators}/${code}/kyc-history`);
}
export function getKycStatusRemarks(currStatus, prevStatus) {
  return buildApiRequest(
    'GET',
    `${urls.operators}/kyc-status/remarks?currentStatus=${prevStatus}&updatedStatus=${currStatus}`,
  );
}

export function getBasicDetailsOperatorRequest(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/basic-details/${opCode}`);
}

export function getAddressDetailsOperatorRequest(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/address-details/${opCode}`);
}

export function getCompliancesDetailsOperatorRequest(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/compliances/${opCode}`);
}

export function getDocumentDetailsOperatorRequest(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/documents/${opCode}`);
}

export function getVehicleDetailsOperatorRequest(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/get-vehicles/${opCode}`);
}

export function getUploadedDocumentUrlRequest(params) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/view-url/${params.docType}/${params.resourceKey}`);
}

export function sendUnderTakingLinkUrl(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/send-undertaking-link/${opCode}`);
}

export function sendTdsLinkUrl(opCode) {
  return buildApiRequest('GET', `${urls.operatorBasicDetails}/send-tds-link/${opCode}`);
}

export function updateOperatorBasicDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorBasicDetails}/basic-details`, { ...payload });
}

export function updateOperatorAddressDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorBasicDetails}/address-details`, { ...payload });
}

export function updateOperatorComplaincesDetailsUrl(payload) {
  return buildApiRequest('PUT', `${urls.operatorBasicDetails}/compliances`, { ...payload });
}

export function updateOperatorVehiclesDetailsUrl(payload) {
  return buildApiRequest('PUT', `${urls.operatorBasicDetails}/update-vehicles`, { ...payload });
}

export function updateOperatorTdsDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.operatorBasicDetails}/tds`, { ...payload });
}

export function updateOperatorDocumentDetailsRequest(payload) {
  return buildApiRequest('POST', `${urls.operatorBasicDetails}/add-documents`, { ...payload });
}

export function getOperatorDocuments(id) {
  return buildApiRequest('GET', `${urls.operatorsList}/${id}/document`);
}

export function tripCountRequest(id) {
  return buildApiRequest('GET', `${urls.operatorsList}/${id}/settle-counts`);
}

export function companyDetailsRequest(id) {
  return buildApiRequest('GET', `${urls.operatorsList}/${id}/company-details`);
}

export function getBankAccountByOpId(opId) {
  return buildApiRequest('GET', urls.bankByOpId, { opId: opId });
}

export function getFormConfigRequest() {
  return buildApiRequest('GET', urls.getFormConfig);
}

export function getRcConfigRequest() {
  return buildApiRequest('GET', urls.getRcConfig);
}

export function getConsignerSuggestionsRequest(text) {
  return buildApiRequest('GET', urls.getConsignerList, { expression: text, pageNo: 0, size: 30, type: null });
}

export function getSaveRcDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/rc-details`, { ...payload });
}

export function getSaveInvoiceRequest(payload) {
  return buildApiRequest('POST', `${urls.getConsignments}/document`, {
    ...payload.payload,
  });
}

export function uploadOperatorIdentityDocumentRequest(payload) {
  return buildApiRequest('POST', `${urls.operatorBasicDetails}/upload-url`, payload);
}

export function uploadPodDocumentRequest(payload) {
  return buildApiRequest('POST', `${urls.getUtils}/upload-url`, payload);
}

export function postIdentityDocument(payload) {
  return buildApiRequest('POST', `${urls.requestURL}`, { payload });
}

export function getUpdateInvoiceRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/doc-update`, {
    ...payload.payload,
  });
}

export function getUpdateInsuranceRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.payload.consignmentId}/document/insurance`, {
    ...payload.payload,
  });
}

export function getPodStatusApiUrl(payload) {
  return buildApiRequest('PUT', `${urls.updatePodStatusAPiUrl}${payload.consignmentId}`, { status: payload.status });
}

export function getLaneSuggestionsRequest(text) {
  return buildApiRequest('GET', urls.getLaneList, { oId: 53, searchText: text });
}

export function viewValidationDocRequest(params) {
  return buildApiRequest('GET', `${urls.getConsignments}/${params.consignmentId}/rc-relation-view-url`, {
    filePath: params.filePath,
  });
}

export function getAddressesRequest(payload) {
  return buildApiRequest(
    'GET',
    `${urls.getAddress}/?consigner-code=${payload.consignerCode}&type=${payload.type}&expression=${payload.searchString}`,
  );
}

export function createDemandRequest(payload) {
  return buildApiRequest('POST', urls.createDemand, payload);
}

export function addLaneRequest(payload) {
  return buildApiRequest('POST', urls.addLane, payload);
}

export function addAddressDemandRequest(payload) {
  return buildApiRequest('POST', urls.createConsignerAddress, payload);
}

export function deleteExpenseRequest(payload) {
  return buildApiRequest('DELETE', `${urls.addExpense}/${payload.id}`, {
    deleted: true,
    partyType: payload.partyType,
  });
}

export function updateLocationRequest(payload) {
  return buildApiRequest('POST', urls.updateLocation, payload);
}

export function updateStoppageReasonRequet(payload) {
  return buildApiRequest('PUT', `${urls.stoppageReasonUpdate}`, payload);
}

export function vehicleStateRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.consignmentId}/vehicle-state`, payload.payload);
}

export function loginRequest(payload) {
  return buildApiRequest('POST', urls.login, { ...payload });
}

export function buildApiRequest(requestMethod, path, params, isFileUpload = false) {
  let request;
  if (path.includes('setDisable') || path.includes('updateToThirdParty')) {
    request = axios({
      method: requestMethod,
      url: path,
      params: params,
      headers: {
        'X-GOOGLE-TOKEN': getCookie('googleAuth'),
      },
    });
  } else {
    // params = removeEmptyParams(params);
    const headers = {
      ...(getCookie('authToken') === '' && { 'X-GOOGLE-TOKEN': getCookie('googleAuth') }),
      ...(getCookie('authToken') !== '' && { 'X-AUTH-TOKEN': getCookie('authToken') }),
    };
    if (isFileUpload) {
      headers['Content-Type'] = 'application/octet-stream';
    }
    if (!!params?.setSourceAsGoogle) {
      headers['search-source'] = 'GOOGLE';
      delete params.setSourceAsGoogle;
    }
    request = axios({
      method: requestMethod,
      url: path,
      ...(((requestMethod === 'GET' || requestMethod === 'DELETE') && { params: params }) || { data: params }),
      headers: headers,
    });
  }
  return request;
}

export function buildFileUploadRequest(path, params) {
  let request;
  request = fetch(path, {
    headers: {
      'X-GOOGLE-TOKEN': getCookie('googleAuth'),
    },
  })
    .then((response) => response.json())
    .then((response) =>
      Promise.all([
        response,
        fetch(response.data.uploadUrl, {
          method: 'PUT',
          headers: {
            'X-GOOGLE-TOKEN': getCookie('googleAuth'),
            'Content-Type': 'application/octet-stream',
          },
          body: params,
        }),
      ]),
    )
    .then(([response, resp]) => {
      return { resp: response.data.name, res: resp };
    });

  return request;
}

// export function consignerBillingDetails({ code, id }) {
//   return buildApiRequest('GET', `${urls.consignerBillingDetails}/${id}/billing-account-details`);
// }

// export function consignerTransactionsList({ code, id }) {
//   return buildApiRequest('GET', `${urls.transactionsListUrl}`);
// }
// export const postIdentityDocument = ()
// export function consignerBillingDetails({ code, id }) {
//   return buildApiRequest('GET', `${urls.consignerBillingDetails}/${id}/billing-account-details`);
// }

// export function consignerTransactionsList(params) {
//   return buildApiRequest('GET', urls.transactionsListUrl, { pageNo: params.page, size: params.size });
// }

export function indentsListRequestTicket(params) {
  return buildApiRequest('GET', `${urls.getIssueTicket}`, params);
}

export function getBasicDetailsRequestTicket(consignmentId) {
  return buildApiRequest('GET', `${urls.getIssueTicket}/${consignmentId}/basic-details`);
}

export function addNewTicketApi(payload) {
  return buildApiRequest('POST', urls.addticketPost, payload);
}

export function updateTicketDetailsApi(payload, id) {
  return buildApiRequest('PATCH', `${urls.getIssueTicket}/${payload.id}/details`, payload.payload);
}
export function getEmailsListRequestTicket(params) {
  return buildApiRequest('GET', `${urls.getEmailsTicket}`, params);
}

export function getTicketDetailsPageDetailApi(id) {
  return buildApiRequest('GET', `${urls.getIssueTicket}/${id}/details`);
}

export function addNewCommentApi(payload) {
  return buildApiRequest('POST', `${urls.getIssueTicket}/${payload.id}/conversation`, payload.payload);
}

export function getConversationListApi(payload) {
  return buildApiRequest('GET', `${urls.getIssueTicket}/${payload}/conversation`);
}

export function getComments(id) {
  return buildApiRequest('GET', urls.getCommentsList(id));
}

export function getPodDetails(params) {
  return buildApiRequest('GET', `${urls.getPodDetails}?consignment-id=${params}`);
}

export function getPodHistory(consignmentId) {
  return buildApiRequest('GET', `${urls.getPodHistory}/${consignmentId}/pod-history`);
}

export function postPodDetailsRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/update-pod-status`, payload.payload);
}
// export function postPodFileDetailsRequest(payload) {
//   return buildApiRequest('POST', `${urls.getDockets}/submit-pod`, payload);
// }

export function viewPodDocument(params) {
  return buildApiRequest('GET', `${urls.getUtils}/view-url?doc-code=${params}`);
}

export function stopBookingAutomation(payload) {
  return buildApiRequest('POST', `${urls.stopBookingAutomation}`, payload);
}

export const fetchODVTList = (opCode) => {
  return buildApiRequest('GET', urls.getODVTList(opCode));
};
export const addNewODVT = (payload) => {
  return buildApiRequest('POST', urls.addODVTItem, payload);
};
export const updateODVT = (payload) => {
  return buildApiRequest('PATCH', urls.updateODVTItem(payload.id), payload.formData);
};
export const deleteODVT = (odvtId) => {
  return buildApiRequest('DELETE', urls.updateODVTItem(odvtId));
};

export const searchVehicleInformation = (vehicleNumber) => {
  return buildApiRequest('GET', urls.searchByVehicleNumber(vehicleNumber));
};

export const getPodValidityRemarkRequest = (params) => {
  return buildApiRequest('GET', urls.podValidityRemark(params));
};

export const getCancelUncancelTripReasons = (params) => {
  return buildApiRequest('GET', urls.cancellationReasons(params));
};
export const postCancelTrip = (params) => {
  return buildApiRequest('POST', urls.cancelTrip(params.consignmentId), params.payload);
};

export const getStatesDocketRequest = (params) => {
  return buildApiRequest('GET', urls.statesDocket(params));
};

export const getDetailsConfigRequest = (params) => {
  return buildApiRequest('GET', urls.detailsConfig(params));
};

export const getStoppageReasons = () => {
  return buildApiRequest('GET', urls.stoppageReasons());
};
export const getTripMapDetailsRequest = (params) => {
  return buildApiRequest('GET', urls.tripMapDetailsUrl(params));
};

export const getTripItineraryRequest = (params) => {
  return buildApiRequest('GET', urls.tripItinerary(params));
};

export const getDelayReasonsRequest = (params) => {
  return buildApiRequest('GET', urls.getDelayReasonsUrl(params));
};

export const getCancelReasonsRequest = (params) => {
  return buildApiRequest('GET', urls.getCancelReasonsUrl(params));
};

export function saveDelayReasonRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.id}/eta`, payload.payload);
}

export function saveCancelReasonRequest(payload) {
  return buildApiRequest('PUT', `${urls.getConsignments}/${payload.id}/cancellation-reason`, payload.payload);
}

export function getExtraExpenseRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.demandId}/extra-charges`);
}

export const getUpdateConsignerPaymentModeOptions = (params) => {
  return buildApiRequest('GET', urls.getUpdateConsignerPaymentModeOptions(params));
};

export function getTicketEntitiesRequest(ticketId) {
  return buildApiRequest('GET', urls.getTicketingEntity(ticketId));
}
export function postTicketEntitiesRequest(payload) {
  return buildApiRequest('PUT', urls.postTicketingFields(), payload);
}

export const getConsignerBusinessDetails = ({ consignerCode }) => {
  return buildApiRequest('GET', urls.consignerBusinessDetails(consignerCode));
};

export const saveConsignerBusinessDetails = ({ consignerCode, payload }) => {
  return buildApiRequest('POST', urls.consignerBusinessDetails(consignerCode), payload);
};

export function getUploadedDocumentUrlRequest2(params) {
  return buildApiRequest('GET', urls.getViewImage(params.resourceKey, params.fileName));
}
export function uploadPostDocumentRequest(params) {
  return buildApiRequest('POST', urls.uploadDocumentFle, params);
}

export function updateReferenceIdRequest(payload) {
  return buildApiRequest('PUT', urls.updateReferenceId, payload);
}

export function createBulkDemandPTLRequest(payload) {
  return buildApiRequest('POST', urls.createBulkDemandPTL, payload);
}

export function createPTLBulkMISRequest({ tpt, ...restPayload }) {
  return buildApiRequest('POST', urls.ptlBulkMIS(tpt), restPayload.payload);
}

export function createFetchPTLBulkMISTransportersRequest() {
  return buildApiRequest('GET', urls.ptlBulkMISTransporters);
}

export function ptlFreightUploadRequest(payload) {
  return buildApiRequest('POST', urls.ptlFreightUpload, payload);
}

export function getPaymentBillingDataRequest(payload) {
  return buildApiRequest('GET', urls.getPaymentBillingData(payload.params.demandId));
}

export function submitPaymentBillingRequest(payload, id) {
  return buildApiRequest('POST', urls.getPaymentBillingData(id), payload);
}

export function submitConfirmationRequest(params) {
  return buildApiRequest('POST', urls.postConfirmation(params.code));
}

export function submitDocketImage(params) {
  return buildApiRequest('PUT', urls.submitDocketImage(params.consignmentId), { attachments: params.attachments });
}

export function getImageProofDocketDetails(params) {
  return buildApiRequest('GET', urls.getImageProofDocketDetails(params));
}

export function submitDelayModal(params) {
  return buildApiRequest('PUT', urls.submitDelayModal(params.id), params.payload);
}

export function getDelayModal(params) {
  return buildApiRequest('GET', urls.getDelayModal(params.id));
}

export function getTicketsByConsignmentApi(payload) {
  console.log(payload, 'payload00');
  return buildApiRequest('GET', urls.getTicketsByConsignment(payload.code, payload.source));
}

export function generateEwayBillNumber(ewayBillNumber, consignmentId) {
  return buildApiRequest('POST', urls.generateEwayBillNumber(ewayBillNumber, consignmentId));
}

export function checkBiltiStatus(params) {
  return buildApiRequest('GET', urls.checkBiltiStatus(params.ewayNumber, params.consignmentId));
}
